// extracted by mini-css-extract-plugin
export default {"JobAds":"EventsAds_JobAds__RgOd0","close_button":"EventsAds_close_button__HF8jq","ads_mod":"EventsAds_ads_mod__dZ5cy","fav_pop_up":"EventsAds_fav_pop_up__SXzTF"};